// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__sdw0F","main_wrapper":"Layout_main_wrapper__KVauj","main":"Layout_main__Pmq7p"};